import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { pickBy, identity } from 'lodash'

import { Formik, Checkbox } from '@components/Form'

import {
  getHouseAsArray,
  getApartmentAsArray,
  getComercialAsArray,
  getAllCategoriesAsArray,
} from '@utils/category'

import { Container, InputLabel, Label, Popover, Button } from './styles'
import { Arrow } from '@icons'

import './index.css'

const house = getHouseAsArray()
const apartment = getApartmentAsArray()
const comercial = getComercialAsArray()
const all = getAllCategoriesAsArray()

const selectCategory = (checked, props, elements) => {
  elements.forEach(({ name }) => {
    props.setFieldValue(name, checked)
  })
}

const verifyAllOptions = (elements, values) => {
  for (let el of elements) {
    if (!values[el.name]) return false
  }

  return true
}

const prepareLabel = (options, values, category = false) => {
  let inputLabel = ''
  if (values) {
    delete values.allFilter
    delete values.apartmentFilter
    delete values.houseFilter
    delete values.comercialFilter
    delete values.othersFilter

    const selectedOptions = Object.keys(values)

    if (category) {
      selectedOptions.forEach((option, index) => {
        options.forEach(({ name, prettyName }) => {
          if (name === option && index === selectedOptions.length - 1)
            inputLabel += prettyName
          else if (name === option) inputLabel += `${prettyName}, `
        })
      })
    } else {
      selectedOptions.forEach((option, index) => {
        options.forEach(({ name, label }) => {
          if (name === option && index === selectedOptions.length - 1)
            inputLabel += label
          else if (name === option) inputLabel += `${label}, `
        })
      })
    }
  }

  return inputLabel
}

class MultiSelect extends Component {
  constructor() {
    super()
    this.state = {
      active: false,
    }
  }

  toggleContainer = () => {
    this.setState(state => ({ active: !state.active }))
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  handleSubmitForm = values => {
    const { name, onChange, category } = this.props
    const pickedValues = pickBy(values, identity)
    let items = null

    if (Object.keys(pickedValues).length === 0) items = ''
    else items = pickedValues

    if (category && items) {
      delete items.allFilter
      delete items.apartmentFilter
      delete items.houseFilter
      delete items.comercialFilter
      delete items.othersFilter
    }

    onChange(name, items)
    this.toggleContainer()
  }

  handleClick = e => {
    const { active } = this.state
    if (
      (this.node && this.node.contains(e.target)) ||
      this.button.contains(e.target)
    ) {
      return
    }

    this.submit && active && this.submit()
  }

  handleButtonClick = () => {
    const { active } = this.state
    this.submit && active && this.submit()
    !active && this.toggleContainer()
  }

  renderMacroCheckbox = (name, label, props, elements) => {
    return (
      <Row between="xs">
        <Col>
          <Checkbox
            name={name}
            checked={verifyAllOptions(elements, this.formValues)}
            label={label}
            onChange={(name, value) => {
              selectCategory(value, props, elements)
              props.setFieldValue(name, value)
            }}
          />
        </Col>
      </Row>
    )
  }

  renderMicroCheckboxes = (elements, props) => {
    return elements.map(({ name, prettyName }) => (
      <Row between="xs" key={name} className="sub-option">
        <Col>
          <Checkbox
            name={name}
            label={prettyName}
            checked={this.formValues && this.formValues[name]}
            onChange={(name, value) => props.setFieldValue(name, value)}
          />
        </Col>
      </Row>
    ))
  }

  render() {
    const {
      label = '',
      disabled,
      category = false,
      values,
      options,
    } = this.props
    const { active } = this.state

    return (
      <Container>
        {label && <InputLabel>{label}</InputLabel>}
        <Button
          type="button"
          onClick={this.handleButtonClick}
          disabled={disabled}
          ref={el => (this.button = el)}
        >
          <Label>
            {prepareLabel(category ? all : options, values, category) ||
              'Selecione'}
          </Label>
          <Arrow />
        </Button>
        {active && (
          <Formik onSubmit={this.handleSubmitForm} initialValues={values}>
            {({ values, handleSubmit, ...props }) => {
              this.formValues = values
              this.submit = handleSubmit
              return (
                <Popover ref={el => (this.node = el)}>
                  {category ? (
                    <React.Fragment>
                      {this.renderMacroCheckbox(
                        'allFilter',
                        'Todos',
                        props,
                        all,
                      )}
                      {this.renderMacroCheckbox(
                        'apartmentFilter',
                        'Apartamento',
                        props,
                        apartment,
                      )}
                      {this.renderMicroCheckboxes(apartment, props)}
                      {this.renderMacroCheckbox(
                        'houseFilter',
                        'Casa',
                        props,
                        house,
                      )}
                      {this.renderMicroCheckboxes(house, props)}
                      {this.renderMacroCheckbox(
                        'comercialFilter',
                        'Comercial',
                        props,
                        comercial,
                      )}
                      {this.renderMicroCheckboxes(comercial, props)}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {options.map(option => (
                        <Row between="xs" key={option.name + option.label}>
                          <Col>
                            <Checkbox
                              name={option.name}
                              label={option.label}
                              checked={values[option.name]}
                              onChange={(name, value) => {
                                props.setFieldValue(name, value)
                              }}
                            />
                          </Col>
                        </Row>
                      ))}
                    </React.Fragment>
                  )}
                </Popover>
              )
            }}
          </Formik>
        )}
      </Container>
    )
  }
}

export default MultiSelect
